import { defineRecipe } from "@chakra-ui/react";

export const buttonRecipe = defineRecipe({
  base: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: "auto",
    gap: 2,
    py: 2,
    paddingBlock: 2,
    paddingInline: 4,
    borderRadius: 20,
    border: "1px solid transparent",
    whiteSpace: "nowrap",
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "1.25rem",
    transitionProperty:
      "background-color, border-color, color, fill, stroke, opacity, box-shadow, translate, transform",
    transitionDuration: "0.2s",
    transitionTimingFunction: "ease-in-out",
    _expanded: {
      bg: "inherit",
    },
  },
  variants: {
    visual: {
      plain: {
        color: "{colors.fg}",
        bg: "#edf2f7",
        _hover: {
          bg: "color-mix(in srgb, #edf2f7 90%, black)",
        },
      },
      primary: {
        color: "#fff",
        bg: "link",
        _hover: {
          bg: "color-mix(in srgb, {colors.link} 90%, black)",
        },
      },
      primaryOutline: {
        color: "link",
        border: "2px solid {colors.link}",
        bg: "transparent",
        _hover: {
          bg: "color-mix(in srgb, transparent 90%, {colors.link})",
        },
      },
      secondary: {
        color: "#fff",
        bg: "#319795",
        _hover: {
          bg: "color-mix(in srgb, #319795 90%, black)",
        },
      },
      light: {
        color: "inherit",
        bg: "#fff",
        _hover: {
          bg: "color-mix(in srgb, #fff 90%, black)",
        },
      },
      outlineLight: {
        border: "2px solid #fff",
        bg: "transparent",
        _hover: {
          bg: "color-mix(in srgb, transparent 90%, #fff)",
        },
      },
      link: {
        textDecoration: "underline",
        bg: "none",
        color: "inherit",
        padding: 0,
        height: "auto",
        minWidth: 0,
      },
      unstyled: {
        color: "inherit",
        bg: "none",
        _hover: {
          bg: "none",
        },
      },
      danger: {
        color: "#fff",
        bg: "#e53e3e",
        _hover: {
          bg: "color-mix(in srgb, #e53e3e 90%, black)",
        },
      },
      dangerOutline: {
        color: "#e53e3e",
        border: "2px solid currentColor",
        bg: "#fff",
        _hover: {
          bg: "color-mix(in srgb, #e53e3e 5%, white)",
        },
      },
    },
    size: {
      xxs: {
        padding: "2px",
        fontSize: 10,
        height: "auto",
        minWidth: 0,
      },
      xs: {
        px: 3,
        py: 1,
        fontSize: 12,
        height: "auto",
      },
      lg: {
        py: 3,
      },
    },
  },
  defaultVariants: {
    visual: "plain",
  },
});
